export function KlaviyoEmbedForm({htmlString}) {
  return <div dangerouslySetInnerHTML={{__html: htmlString}} />;
}
